// extracted by mini-css-extract-plugin
module.exports = {"ui":"button_ui__SZfVk","inverse":"button_inverse__Xnck4","outline":"button_outline__0vfk8","grid":"button_grid__Gi7Wm","button":"button_button__Z_nZr"};